import { render } from "./Special.vue?vue&type=template&id=c493233a&scoped=true&ts=true"
import script from "./Special.ts?vue&type=script&lang=ts"
export * from "./Special.ts?vue&type=script&lang=ts"

import "./Special.scss?vue&type=style&index=0&id=c493233a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c493233a"]])

export default __exports__